import React from "react";
import "./Dashboard.css";
import Typography from '@mui/material/Typography';
import { Box } from "@mui/material";


function Search() {
    return (
        <select className="searchSelect" name="searchSelect" id="searchSelect" components={{ DropdownIndicator:() => null, IndicatorSeparator:() => null }}>
            <option value="search"> </option>
            {/*<option value="search">Search</option>
            <option value="search">Overview</option>
            <option value="search">Energy Analytics</option>
            <option value="search">Energy Accounting</option>
            <option value="search">Power Quality</option>
            <option value="search">Environment</option>*/}
        </select>
    );
}

export default Search;


{/*

    <Box className="searchSelect" sx={{alignContent:'center'}}>
            <Typography  sx={{textAlign:'left'}} >
                Search
            </Typography>
        </Box>



*/}